import type { CheckboxProps } from 'uikit';
import { Checkbox } from 'uikit';

import type React from 'react';
import { useEffect, useCallback } from 'react';
import type { Control } from 'react-hook-form';
import { useController } from 'react-hook-form';

interface IControlledCheckboxProps extends Omit<CheckboxProps, 'checked'> {
    name: string;
    control: Control<any>;
    clearOnDisabled?: boolean;
}

export const ControlledCheckbox = ({
    name,
    control,
    required,
    clearOnDisabled,
    ...checkboxProps
}: IControlledCheckboxProps) => {
    const {
        field: { value, onChange },
    } = useController({
        name,
        control,
        rules: { required },
    });

    const handleChangeCheckbox = useCallback(
        (evt: { e: React.ChangeEvent<HTMLInputElement>; checked: boolean }) => {
            onChange(evt.checked);
        },
        [onChange],
    );

    useEffect(() => {
        if (checkboxProps?.disabled && clearOnDisabled) {
            onChange(false);
        }
    }, [checkboxProps?.disabled, clearOnDisabled, onChange]);

    return (
        <Checkbox
            intermediate={value === 'intermediate'}
            checked={value}
            onChange={handleChangeCheckbox}
            {...checkboxProps}
        />
    );
};

ControlledCheckbox.displayName = 'ControlledCheckbox';
